import { Theme } from '@mui/material';

/**
 * style object for ccf-interaction-search
 * @returns FilterStyle object
 * @example FilterStyle()
 */
const FilterStyle = (theme: Theme) => {
  const styles = {
    parentContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: '0.625rem 0.938rem',
    },
    interactionSearchTitle: {
      color: theme?.palette?.text?.searchTitle,
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: '1.188rem',
    },
    searchInput: {
      input: {
        padding: '0.25rem 0.313rem 0.25rem 0',
      },
      width:'100%',
      '& .MuiInputBase-adornedStart':{
        paddingLeft:'0.3rem',
      },
      '& .MuiInputBase-adornedEnd':{
        paddingRight:'0rem',
      },
      '& .MuiOutlinedInput-input':{
        padding: '0.3rem',
      },
      '& .MuiOutlinedInput-notchedOutline':{
        paddingRight: 0,
      },
      '& svg':{
        right:'0rem',
      },
    },
    button: {
      width: 'auto',
      height: '1.875rem',
      padding: '0.563rem 1.25rem 0.563rem 1.125rem',
      color: theme?.palette?.text?.searchTitle,
      borderColor: theme?.palette?.border?.main,
      alignContent: 'center',
      fontSize: '0.688rem',
      fontWeight: 800,
      textOverflow: 'ellipsis',
      overflow:'hidden',
      whiteSpace:'nowrap',
    },
    filterIcon: {
      width: '0.8rem',
      color: theme?.palette?.text?.grey,
    },
    menuOptions: {
      fontSize: '0.75rem',
      fontWeight: 800,
    },
    buttonsAndSearchBox: {
      display: 'flex',
      gap: 1,
    },
    titleAndMenuBox: {
      display: 'flex',
      justifyContent: 'space-between',
      '& label': {
        color: theme?.palette?.text?.secondary,
      },
      '& svg': {
        marginLeft: '-1rem',
      },
    },
    listSubheader: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '0.5rem',
      paddingRight: '0.5rem',
    },
    customizeText: { 
      fontWeight: 700,
      color: theme?.palette?.text?.black,
      fontSize: '0.75rem',
    },
    closeIcon: {
      cursor: 'pointer',
      color: theme?.palette?.text?.black,
    },
    menuItem: {
      cursor: 'grab',
      padding: '0 0.5rem',
    },
    divider: {
      borderColor: theme?.palette?.text?.grey,
    },
    menu: {
      '& .MuiMenu-paper': {
        border: `1px solid ${theme?.palette?.text?.grey}`,
        '&::-webkit-scrollbar': {
          width: '0.3rem',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: theme?.palette?.background?.scrollThumb,
          borderRadius: '2rem',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: theme?.palette?.background?.scrollTrack,
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: theme?.palette?.background?.scrollThumbHover,
        },
        '& .MuiMenu-list': {
          paddingTop: 0,
          paddingBottom: 0,
        },
      },
    },
    listBox:  {
      '& .MuiPaper-root': {
        border: `1px solid ${theme?.palette?.text?.grey}`,
        '&::-webkit-scrollbar': {
          width: '0.3rem',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: theme?.palette?.background?.scrollThumb,
          borderRadius: '2rem',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: theme?.palette?.background?.scrollTrack,
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: theme?.palette?.background?.scrollThumbHover,
        },
      },
    },
    filtersText: { 
      fontWeight: 700,
      color: theme?.palette?.text?.filter,
      fontSize: '0.875rem',
      marginLeft: '-0.438rem',
    },
    applyButton: {
      width: '1.25rem',
      height: '1.875rem',
      padding: '0.563rem 1.25rem 0.563rem 1.125rem',
      color: theme?.palette?.text?.white,
      borderColor: theme?.palette?.border?.main,
      alignContent:'center',
      fontSize:'0.688rem',
      fontWeight: 800,
      backgroundColor: theme?.palette?.text?.noteLabel,
      '&:hover': {
        backgroundColor: theme?.palette?.text?.noteLabel,
      },
    },
    filterMenuItem : {
      maxWidth:'15.625rem', 
      fontSize: '0.75rem', 
      textOverflow:'ellipsis',
      overflow:'hidden',
      whiteSpace:'nowrap',
      height: '2rem',
    },
    dropdownBox: {
      width: '100%',
      maxHeight: 'calc(100vh - 110px)',
      display:'flex', 
      flexDirection:'column',
    },
    dropdownLabels: {
      fontSize:'0.813rem',
      fontWeight: 600,
    },
    contactInfo: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      border: `0.063rem solid ${theme?.palette?.border?.main}`,
      margin: '0.625rem',
      width: '30%',
      maxHeight: '70%',
      overflowY: 'scroll',
      backgroundColor: theme?.palette?.text?.white,
      [theme.breakpoints.down(480)]: {
        width: '60%',
      },
    },
    gridBackground: {
      backgroundColor: `${theme?.palette?.background?.light}`,
    },
    searchBox: {
      display: 'flex',
      width: '100%',
      color: theme?.palette?.secondary?.main,
    },
    searchOption: {
      height: '1.6rem',
      lineHeight: '1.6rem',
      fontSize: '0.8rem',
      color: theme?.palette?.secondary?.main,
    },
    searchOptionControl:{
      width: '4.8rem',
    },
    searchOptionList:{
      fontSize: '0.8rem',
    },
    searchCloseIcon: {
      color: theme?.palette?.secondary?.main,
    },
  }
  return styles;
}
export default FilterStyle;